import React, { useEffect } from 'react'
import SelectInput from '../inputs/select-input'
import TextInput from '../inputs/text-input'
import _ from 'lodash'

const StringMatch = ({data, types, columns, onRemove, onChange, onTransform}) => {
  const conditions = [['~*', 'contains'], ['!~*', 'does not contain'], 
    ["= ''", 'is empty'], ["!= ''", 'is not empty']]
  const shortForm = data.condition == "= ''" || data.condition == "!= ''"

  useEffect(() => {
    if (!data.condition) onChange({...data, condition: conditions[0][0], completed: false})
  }, [data.column])

  const showParams = (params) => {
    return params.condition == "= ''" || params.condition == "!= ''"
  }

  const isCompleted = (params) => {
    if (showParams(params)) return true
    return !!params.value?.trim()
  }

  const changeData = (params) => {
    const newData = {...data, ...params, completed: false, query: undefined}
    if (isCompleted(newData)) {
      newData.completed = true
      newData.query = query(newData)
    }
    onChange({...data, ...newData})
  }

  const query = (params) => {
    if (showParams(params)) return `${params.column} ${params.condition}`
    return `${params.column} ${params.condition} '${_.escapeRegExp(params.value)}'`
  }

  return (
    <div className='filter-row'>
      { !data.type && <span className='where'>Where</span> }
      { data.type && 
        <SelectInput
          name='type'
          options={types}
          value={data.type}
          onChange={e => changeData({type: e.target.value})}
        />
      }
      <SelectInput
        name='column'
        options={columns}
        value={data.column}
        onChange={e => onTransform(e.target.value)}
      />
      <SelectInput
        name='condition'
        options={conditions}
        value={data.condition || conditions[0][0]}
        onChange={e => changeData({condition: e.target.value})}
      />
      { !shortForm &&
        <TextInput
          name='value'
          value={data.value || ''}
          onChange={e => changeData({value: e.target.value})}
        />
      }
      <button className='remove' onClick={onRemove}><i className='fa fa-trash-o' /></button>
    </div>
  )
}

export default StringMatch
